const initHeaderAudio = () => {
	let $headerAudio = $('.home-header');
	let $headerPlay = $('.header__play');
	let $headerPause = $('.header__pause');
	let $beginButtonOn = $('.begin__on');

	$headerAudio.on('play', () => {
		$headerPause.addClass('is-active');
		$headerPlay.removeClass('is-active');
	});

	$headerAudio.on('pause', () => {
		$headerPause.removeClass('is-active');
		$headerPlay.addClass('is-active');
	});

	$headerPlay.on('click', () => {
		$headerAudio[0].play();
		$headerAudio[0].volume = 0.6;
	});

	$headerPause.on('click', () => {
		$headerAudio[0].pause();
	});

	$beginButtonOn.on('click', (e) => {
		$(e.currentTarget).addClass('is-active');

		$headerAudio[0].play();
		$headerAudio[0].volume = 0.6;
	});	
};

initHeaderAudio();
